module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Regular.fd077957.ttf";